import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { getApiBaseUrl, getDomainWithoutSubdomain } from "../../utils/domain";

const initialState = {
  logoUrl: "",
  // Keep true initially so UI can avoid rendering fallback logo
  // before the first branding API call resolves.
  loading: true,
  error: null,
};

const extractLogoUrl = (payload) =>
  payload?.data?.description ||
  payload?.description ||
  payload?.data?.url ||
  payload?.url ||
  (typeof payload === "string" ? payload : "");

export const fetchLogo = createAsyncThunk("logo/fetchLogo", async (_, { rejectWithValue }) => {
  try {
    const baseUrl = getApiBaseUrl();
    const domainData = getDomainWithoutSubdomain(baseUrl);

    const response = await axiosInstance.post("/content/getLogo", {
      key: btoa(domainData),
    });

    return response;
  } catch (error) {
    return rejectWithValue(error?.response?.data || error?.message || "Failed to fetch logo");
  }
});

const logoSlice = createSlice({
  name: "logo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLogo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLogo.fulfilled, (state, action) => {
        state.loading = false;
        state.logoUrl = extractLogoUrl(action.payload);
      })
      .addCase(fetchLogo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.payload || "Failed to fetch logo";
        state.logoUrl = "";
      });
  },
});

export default logoSlice.reducer;
